<template>
    <div>
        <el-breadcrumb separator-class="el-icon-arrow-right">
            <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
            <el-breadcrumb-item>商品管理</el-breadcrumb-item>
            <el-breadcrumb-item>组合商品管理</el-breadcrumb-item>
        </el-breadcrumb>
        <el-card>

            <div class="kaidan_body">
                <div style="width: 100px;min-width: 100px; " v-if="true">
                    <el-steps :active="cardShow - 1" align-center direction="vertical">
                        <el-step title="选择商品" description="选择商品" @click.native="menu_set(1)"></el-step>
                        <el-step title="赠品配置" description="赠品配置" @click.native="menu_set(2)"></el-step>
                    </el-steps>
                </div>
                <div style="width: 100%;" class="kaidan">
                    <div class="kaidan">
                        <el-card v-if="cardShow_xianshi === 1" class="card_style">
                            <div v-if="cardShow_sub === 1">
                                <product ref="productListRef" caozuo_type="1" @getProductInfo="getProductInfo"> </product>
                            </div>
                        </el-card>
                        <el-card v-if="cardShow_xianshi === 2" class="card_style">
                            <div class="mendian_body">
                                <div style="width: 80px;">产品信息</div>
                                <div style="width: 80px;"></div>
                                <div style="width: 250px;">
                                    <span style="width: 200px;">编号: </span>
                                    <span class="mendianInfo">{{ productUidInfo.bianhao }}</span>
                                </div>
                                <div style="width: 250px;">
                                    <span style="width: 80px;"> 名称: </span>
                                    <span class="mendianInfo">{{ productUidInfo.pro_name }}</span>
                                </div>
                                <div>
                                    <span style="width: 80px;">市场价: </span>
                                    <span class="mendianInfo">{{ productUidInfo.price_shichang
                                    }}</span>
                                </div>
                            </div>
                            <div v-if="cardShow_sub === 1">
                                <zuheShangpinDo ref="zuheDoRef" caozuo_type="1" @closeAdd="closeAdd"
                                    :productUidInfo="productUidInfo" key="datekey">
                                    <!-- productUidInfo 传递选择的归属产品所有信息 到 do页面 -->
                                </zuheShangpinDo>
                            </div>

                        </el-card>
                    </div>
                </div>
            </div>
        </el-card>
        <div style="margin-top: 10px;text-align: center;"><span slot="footer" class="dialog-footer">
                <el-button @click="quxiao">关闭窗口</el-button>
                <el-button type="primary" @click="addZengpin" :disabled="add_isDisable">{{ button_text }}</el-button>
            </span> </div>
    </div>
</template>
<script>
import { checkMobileTest, checkSfzId } from '../config/validator';

import zuheShangpinDo from './zuheShangpin_do.vue'
import product from './productSelect.vue'
export default {
    components: {
        zuheShangpinDo: zuheShangpinDo,
        product: product
    },
    data() {
        return {
            mendianUidInfo: { uid: 0 },
            errFlag: 0,
            datekey: Date.now(),
            // editUid_cheliang: 0, // 修改uid
            // car_update_flag: 0, // 是否为新添加 车辆资料 1 新车型 2 已有车型
            // guest_update_flag: 0, // 是否为新添加客户， 1位新客户 2为已有客户
            array_cardShow_sub: [],
            // kaidan_title: '01-01:请输入车牌',
            button_text: '保存',
            // isCollapse002: true,
            cardShow: 1, // 主模块控制标记
            cardShow_sub: 1, // 子元素显示标记
            add_isDisable: false,
            cardShow_xianshi: 1// 用于显示
        };
    },
    created() {
        // this.getorderList();
        console.log('强制刷新')
        // this.getBianhao_order()
    },
    methods: {

        closeAdd() {
            // delay
            this.cardShow = 1
            this.cardShow_sub = 1
            this.cardShow_xianshi = this.cardShow
            // this.$refs.mendianListRef.mendianUidSelect = 0
            this.$emit('flushProductList', '')
        },
        async addZengpin() {
            if ((this.cardShow === 1) && (this.cardShow_sub === 1)) {
                if (this.productUidInfo.uid === 0) {
                    this.$message.error('请选择商品！')
                    return 0
                }
                if ((this.cardShow === 1) && (this.cardShow_sub === 1)) {
                    this.kaidan_title_set(2)
                    this.cardShow = 2
                    this.cardShow_xianshi = this.cardShow
                    this.cardShow_sub = 1
                }
                return 1
            }
            if ((this.cardShow === 2) && (this.cardShow_sub === 1)) {
                await this.$refs.zuheDoRef.zuheShangpinAdd()
                this.$emit('flushKucunPage', 1)
                console.log(99901)
                return 1
            }
        },
        getProductInfo(productUidInfo) {
            this.productUidInfo = productUidInfo
            console.log(888, this.productUidInfo)
            this.addZengpin()
        },
        get_order_selected_uid(data) {
            console.log('array_order_uid_selected', data)
            this.arrayOrderUidSelected = data
        },

        quxiao() {
            this.$emit('product_zuhe_addClose', 0)
        },
        kaidan_title_set(type) {
            console.log('当前位置', this.cardShow_xianshi, this.cardShow, this.cardShow_sub)
            if (type === 1) {
                this.cardShow_xianshi = this.cardShow
                this.array_cardShow_sub[this.cardShow - 1] = this.cardShow_sub
            }

            return 0
        },
        test_pro() {
            console.log(8888, this.cardShow_xianshi, this.cardShow, this.cardShow_sub, this.addForm)
        },
        err_chuli(type, data) {
            if (data.uid === -1) {
                this.$message.error(type === 1 ? '车辆添加出错' : type === 2 ? '外观添加出错' : '客户添加出错')
                return 0
            }
        }
    }
};
</script>
<style lang="less" scoped>
.card_two {
    margin-top: 30px;
    box-shadow: none !important;
    background-color: #f2f6fc;
}

.el_row_two {
    margin-top: 30px;
    height: 650px;
}

.el-menu-vertical-demo:not(.el-menu--collapse) {
    width: 200px;
    min-height: 400px;
}

.kaidan {
    display: flex;
    flex-direction: column;

}

.card_style {
    height: 700px;
    overflow-y: auto;
}

.kaidan_title {
    background-color: #eee;
    width: 100%;
    height: 40px;
    font-size: 30px;
    color: black;
    border-radius: 5px 5px 0px 0px;
    text-align: center;
    padding-top: 8px;
}

.kaidan_body {
    display: flex;
    flex-direction: row;
    height: 700px;

}

.mendian_body {
    display: flex;
    flex-direction: row;
    height: 60px;
    width: 100%;

}

.card_gundong {
    overflow-y: auto;
    max-height: 500px;
    max-width: 500px;
}

.mendianInfo {
    font-size: large;
    font-weight: 350;
    color: #515151;
    text-decoration: underline;
}
</style>
